import styled from "styled-components";
import { Buttons } from "../../style/themes.style";

export const Container = styled.div`

position: fixed;
    left:0;
    bottom: 5vh;
    `;
export const Button = styled.div`
    ${Buttons}
    padding: 0.1rem;
    font-size: 2rem;


`;